const warnedCallers = new Set<string>();

/**
 * Emits a one-time console warning when legacy WebsiteCountry APIs are used.
 * Development only — omitted in test and production.
 */
function warnLegacyWebsiteCountryUsage(caller: string): void {
  if (process.env.NODE_ENV !== "development") {
    return;
  }

  if (warnedCallers.has(caller)) {
    return;
  }

  warnedCallers.add(caller);

  console.warn(
    `[@homeinstead/locale] ${caller} is deprecated (DEX-2366). Prefer @homeinstead/locale registry helpers; request-time getLocale() lands in DEX-2367.`,
  );
}

export { warnLegacyWebsiteCountryUsage };
